export default "__VITE_ASSET__I$tpFlNJ__"